import { accounts as api_accounts } from "@/api";

// Types
export const CREATE_MOVES_BEGIN = "CREATE_MOVES_BEGIN";
export const CREATE_MOVES_ERROR = "CREATE_MOVES_ERROR";
export const CREATE_MOVES_SUCCESS = "CREATE_MOVES_SUCCESS";

// models
const models = {};

// initial state
const state = () => ({
  creatingMovesLoading: false,
  creatingMovesError: false
});

// getters
const getters = {
  creatingMoves: state => state.creatingMovesLoading,
}

// actions
const createMoveLines = async ({ dispatch, commit, rootState }) => {
  // TODO: isn't better 'currentDocument.id' ??
  const id = rootState.documents.id;
  commit(CREATE_MOVES_BEGIN);
  try {
    await api_accounts.createMoveLines({ id });
    await dispatch("documents/fetchDocument", { id }, { root: true });
    commit(CREATE_MOVES_SUCCESS);
  } catch (error) {
    // TODO: Properly handle call errors
    commit(CREATE_MOVES_ERROR);
    throw error;
  }
};

const actions = {
  createMoveLines,
}

// mutations
const mutations = {
  [CREATE_MOVES_BEGIN](state) {
    state.creatingMovesLoading = true;
    state.creatingMovesError = false;
  },
  [CREATE_MOVES_SUCCESS](state) {
    state.creatingMovesLoading = false;
    state.creatingMovesError = false;
  },
  [CREATE_MOVES_ERROR](state) {
    state.creatingMovesLoading = false;
    state.creatingMovesError = true;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  models
}